import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Newsfile } from './../newsfile';
import { FileUploadService } from './../file-upload.service';
import { Globals } from './../globals';

interface NewsFileExtended extends Newsfile {
  images: string[];
}

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})

export class NewsComponent implements OnInit {

  newsfiles: NewsFileExtended[];
  newsFile: NewsFileExtended;
  loadingTxt: string;
  loading: boolean;
  loadingOk: number;
  @ViewChild('fileInput') fileInput;

  constructor(private httpClient: HttpClient, private fileUploadService: FileUploadService, private globals: Globals) { }

  ngOnInit() {
    this.loadingTxt = '';
    this.loading = false;
    this.loadingOk = 0;
    this.newsfiles = [];
    this.getNews();
    this.newsFile = { id: 0, header: '', content: '', created: new Date(), createdby: '', images: []  };
  }

  getNews() {
    this.httpClient.get<Newsfile[]>('https://www.saaristonsiirin.com/api/getNews.php').subscribe(data => {
    this.newsfiles = [];
    let dataFileExtended: NewsFileExtended;

    data.forEach((dataFile) => {
      dataFileExtended = {
        id: dataFile.id,
        header: dataFile.header,
        content: dataFile.content,
        created: dataFile.created,
        createdby: dataFile.createdby,
        images: []
        };
        this.newsfiles.push(dataFileExtended);
      });

      this.newsfiles.forEach((nFile) => {
        this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/news/' + nFile.id).subscribe(imagedata => {
          nFile.images = imagedata;
        });
      });
    });
  }

  deleteNews($event, newsfile: Newsfile) {
    if (confirm('Oletko varama että haluat poistaa uutisen ' + newsfile.header + '?')) {
    this.httpClient.get('https://www.saaristonsiirin.com/api/delete.php/news/' + newsfile.id).subscribe(() => {
      this.httpClient.get('https://www.saaristonsiirin.com/api/deleteDirectory.php/news/' + newsfile.id).subscribe(() => {
        this.getNews();
      });
    });
  }
  }

  updateNews($event) {
    const newNews: Newsfile = {
      id: this.newsFile.id,
      header: this.newsFile.header,
      content: this.newsFile.content,
      created: this.newsFile.created,
      createdby: this.newsFile.createdby
    };
    if (newNews.id === 0) {
      this.httpClient.post('https://www.saaristonsiirin.com/api/insert.php/news', JSON.stringify(newNews)).subscribe(() => {
        this.getNews();
      });
    } else {
      this.httpClient.post('https://www.saaristonsiirin.com/api/update.php/news/' + newNews.id,
      JSON.stringify(newNews)).subscribe(() => {
        this.getNews();
      });
    }
  }

  createNews($event) {
    this.newsFile = { id: 0, header: '', content: '', created: new Date(), createdby: '', images: []  };
  }

  setNews($event, newsfile: NewsFileExtended) {
    this.newsFile = newsfile;
  }

  showImageButton() {
    return this.newsFile.id > 0;
  }

  upload() {
    this.loadingTxt = 'Lähetän tiedostoa...';
    this.loading = true;
    this.loadingOk = 0;
    const fileBrowser = this.fileInput.nativeElement;
    if (fileBrowser.files && fileBrowser.files[0]) {
      const formData = new FormData();
      formData.append('image', fileBrowser.files[0]);
      this.fileUploadService.upload(formData, this.newsFile.id).subscribe(res => {
        this.loadingOk = res[0];
        this.loadingTxt = res[1];
       this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/news/' + this.newsFile.id).subscribe(imagedata => {
          this.newsFile.images = imagedata;
          this.loading = false;
        });
      });
    }
  }

  deleteFile($event, newsImage: string) {
    this.loadingTxt = 'Poistan tiedostoa...';
    this.loading = true;
    this.loadingOk = 0;
    this.httpClient.get('https://www.saaristonsiirin.com/api/deleteFile.php/news/' + this.newsFile.id + '/' + newsImage).subscribe(() => {
      this.httpClient.get<string[]>('https://www.saaristonsiirin.com/api/getFiles.php/news/' + this.newsFile.id).subscribe(imagedata => {
        this.newsFile.images = imagedata;
        this.loading = false;
        this.loadingTxt = 'Poisto onnistui';
        this.loadingOk = 1;
      });
    });
  }
}



// WEBPACK FOOTER //
// C:/DEV/saaristonsiirin/src/app/news/news.component.ts